import useNotification from "../components/shared/Notifications/useNotifications";

interface Handlers {
  onSuccess: () => void;
  onError: () => void;
}

export default function useDefaultCRUDHandlers(objectName: string): {
  saveHandlers: Handlers;
  deleteHandlers: Handlers;
} {
  const { addNotification } = useNotification();

  const saveHandlers: Handlers = {
    onSuccess: () => {
      addNotification({
        variant: "success",
        primaryText: `${objectName} saved`,
      });
    },
    onError: () => {
      addNotification({
        variant: "error",
        primaryText: `Failed to save ${objectName.toLowerCase()}`,
      });
    },
  };

  const deleteHandlers: Handlers = {
    onSuccess: () => {
      addNotification({
        variant: "success",
        primaryText: `${objectName} deleted`,
      });
    },
    onError: () => {
      addNotification({
        variant: "error",
        primaryText: `Failed to delete ${objectName.toLowerCase()}`,
      });
    },
  };

  return {
    saveHandlers,
    deleteHandlers,
  };
}
